import { endOfDay, endOfMonth, differenceInDays, sub, add } from 'date-fns';

import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { startOfWeek } from 'features/app/utils/startOfWeek';
import { endOfWeek } from 'features/app/utils/endOfWeek';

export const getRangeEnd = (date: Date, chartMode: ChartViewMode, summaryMode = false) => {
  switch (chartMode) {
    case ChartViewMode.Daily:
      return endOfDay(date);
    case ChartViewMode.Weekly:
      if (summaryMode) {
        return add(date, { weeks: 1 });
      }

      return endOfWeek(date);
    case ChartViewMode.Monthly:
      const monthEnd = endOfMonth(date);
      if (summaryMode) {
        return monthEnd;
      }

      const weekEnd = endOfWeek(monthEnd);

      const diff = differenceInDays(monthEnd, startOfWeek(monthEnd));

      if (diff < 6) {
        return sub(weekEnd, { weeks: 1 });
      }
      return weekEnd;
  }
};
